import { useCallback, useEffect, useState } from 'react';

const REPLAY_STEP_INTERVAL_MS = 900;

export const useStoryReplay = ({ items }: { items: readonly unknown[] }) => {
  const total = items.length;
  const [visibleCount, setVisibleCount] = useState<number | null>(null);

  useEffect(() => {
    setVisibleCount(null);
  }, [items]);

  useEffect(() => {
    if (visibleCount === null) {
      return undefined;
    }

    if (visibleCount >= total) {
      setVisibleCount(null);

      return undefined;
    }

    const timer = setTimeout(
      () => setVisibleCount((count) => (count === null ? null : count + 1)),
      REPLAY_STEP_INTERVAL_MS,
    );

    return () => clearTimeout(timer);
  }, [visibleCount, total]);

  const toggle = useCallback(
    () => setVisibleCount((count) => (count === null ? 1 : null)),
    [],
  );

  const revealed = useCallback(
    <T>(items: T[]): T[] =>
      visibleCount === null ? items : items.slice(0, visibleCount),
    [visibleCount],
  );

  return { isReplaying: visibleCount !== null, toggle, revealed };
};
